import React, { useEffect, useMemo, useState } from "react";
import { getTips } from "../getTips";

export default function ParentTips({tips}) {

  if(!tips) return null;

  return (
    <div className="tips sectionContent">
      {tips.map((value, index) => (
        <div className="tip" key={"tip" + index}>
          <div className="tipNumber">{index + 1}.</div>
          <div className="tipText">{value}</div>
        </div>
      ))}
    </div>
  );
}